import Footer from '../../footer/Footer';
import Navbar from '../../navbar/Navbar';
import AboutLeftTab from '../../About/AboutLeftTab';

function TwoDayGenAIHackathon20251117() {

    const images = [
        // "1000375153.jpg ",
        "1000374946.jpg",
        "1000375154.jpg ",
        "1000375155.jpg ",
    ];

    return (
        <div>
            <Navbar />

            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <AboutLeftTab />

                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="col-lg-12 ps-lg-4">
                                <div className="how-to-apply">

                                    <h2 className="pb-2">
                                        Two Day Hackathon on GenAI – In Collaboration with IBM & Smartbridge
                                    </h2>

                                    <p>
                                        Two day Hackathon on <strong>GenAI</strong> for the <strong>Second year students</strong>
                                        was organized in collaboration with <strong>IBM Smartbridge</strong> from
                                        <strong> November 17th – November 18th</strong>.
                                        <br />

                                        SWEC, in collaboration with <strong>IBM</strong> and <strong>Smartbridge</strong>,
                                        launched this Hackathon initiative to align academics and strengthen problem-solving skills.
                                        <br />

                                        A <strong>3–4 day Virtual Instructor-Led Training</strong> was conducted for all second-year
                                        students from <strong>November 14th</strong> to train them on GenAI concepts.
                                        <br />

                                        Students formed teams of <strong>3–4 members</strong> and submitted their Hackathon ideas
                                        on the platform in the given format before the event.
                                        <br />

                                        The <strong>2-day (18–20 hrs)</strong> in-person Hackathon included hands-on development
                                        supported by mentors from the Smartbridge team, following a <strong>50:1 student–mentor ratio</strong>.
                                        <br />

                                        The top <strong>10 teams</strong> were shortlisted through evaluations, and final presentations
                                        were made to the jury. From these, <strong>3 winning teams</strong> were selected.
                                    </p>

                                    <div className="spotlight-group">
                                        <div className="row">
                                            {images.map((img, index) => (
                                                <div key={index} className="col-md-6 mb-3 mb-lg-4">
                                                    <a
                                                        className="spotlight"
                                                        href={`https://admin.swec.ac.in/assetsswec/img/two-day-genai-hackathon-2025/${img}`}
                                                    >
                                                        <img
                                                            src={`https://admin.swec.ac.in/assetsswec/img/two-day-genai-hackathon-2025/${img}`}
                                                            loading="lazy"
                                                            alt={`Two Day GenAI Hackathon Image ${index + 1}`}
                                                            className="img-responsive center-block rounded-1 sixteen-nine"
                                                        />
                                                    </a>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
}

export default TwoDayGenAIHackathon20251117;
